import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Switch, Route } from 'react-router-dom'
import { setHeader, changePlanId, changePlanningTeam } from '../actions'
import { Field, reduxForm } from 'redux-form'
import PlanningForm from '../components/PlanningForm'
import PlanList from '../components/PlanList'

class Plan extends Component {
  componentWillMount() {
    this.initializeHeader()
    this.initializeForm()
  }
  componentDidUpdate() {
    this.initializeHeader()
    this.initializeForm()
  }
  initializeHeader() {
    const { setHeader, url, plans } = this.props
    const header = (url.match(/^\/plan\/edit*/) === null)? {
      title: '目標一覧',
      left: null,
      right: {
        text: '個人目標　<i class="fas fa-edit"></i>',
        url: '/plan/edit'
      }
    } : {
      title: '',
      left: {
        text: 'back',
        url: '/plan/' + plans.selectedTeamId
      },
      right: null
    }
    setHeader(header)
  }
  initializeForm() {
    const { initialize, plans } = this.props
    initialize({
      planId: plans.selectedPlanId,
      team: plans.selectedTeamId
    })
  }
  render() {
    const { changePlanId, changePlanningTeam, url, plans, teams, teamList } = this.props
    return (
      plans.planIds?
        <div className="plan">
          <div className="content select-box">
            <div className="field select is-medium">
              <Field name="planId" component="select" onChange={e => changePlanId(e.target.value)}>
                {plans.planIds.map(key => 
                  <option value={key} key={key}>{key}</option>
                )}
              </Field>
            </div>
            {url.match(/^\/plan\/edit*/) === null ?
              <div className="select field is-medium">
                <Field name="team" component="select" onChange={e => changePlanningTeam(e.target.value)}>
                  <option value="all" key="all">チーム一覧</option>
                  {teamList.map(teamID => 
                    <option value={teamID} key={teamID}>{teams[teamID].name}</option>
                  )}
                </Field>
              </div>
            :
              null
            }
          </div>
          <div className="content">
            {plans.planData && plans.planData[plans.selectedPlanId]?
              <Switch>
                <Route exact path='/plan' component={PlanList} />
                <Route exact path='/plan/edit' component={PlanningForm} />
                <Route path='/plan/edit/:id' component={PlanningForm} />
                <Route path='/plan/:id' component={PlanList} />
              </Switch>
            :
              <div>Loading...</div>
            }
          </div>
        </div>
      :
        <div>Loading...</div>
    )
  }
}

export default connect(
  state => ({
    teams: state.organization.teams,
    teamList: state.organization.teamList,
    plans: state.plans
  }),
  { setHeader, changePlanId, changePlanningTeam }
)(reduxForm({ form: 'planning-selector' })(Plan))


// WEBPACK FOOTER //
// ./src/containers/Plan.js